module.exports = __webpack_public_path__ + "img/3.e5b0e042.jpg";